(function(){


  var linkFunction = function($scope, element, attrs) {

  };

  var controllerFunction = function($scope,ABS,UserSession,webAnalytics,commonFunctionality,RequestServiceHelper,$rootScope) {
    /*webTrendsService.webTrendsUtag("OBJ",{page_name: 'account balance',page_category: 'my account',
      scenario_name: 'reg:OLP',scenario_step: 'balance'});*/
    var utagObj={
      page_name: 'account balance',
      page_category: 'my account',
      scenario_name: 'reg:OLP',
      scenario_step: 'balance'
    };
    $scope.checkNative = cvsUtility.setNativeCheck(); // check if the app is running in native.
    /**
     * Vinoth 02/10/2017 - Feb 2017 Regression defect fix
     * Added logic to take member to payments module in mobile App
     * */
    $scope.goTopaymentUrl = function(){
      if($scope.checkNative){
          native.gotoPage('Payment');
      }else{
         $scope.makePayment();
      }
    }

    if(!$scope.isMyAccountPage){
      setTimeout(function(){webAnalytics.webTrendsUtag("OBJ",utagObj,undefined,"accountBalance"); }, 3000);
    }
  
    $scope.makePayment = function(){
      window.top.location = createChannelUrl('makePayment');
    };
    /**
     * Vinoth 02/10/2017 - Feb 2017 Regression defect fix
     * Added logic to take member to payments module in mobile App
     * */
    $scope.viewHistory = function(){
      if($scope.checkNative){
        native.gotoPage('Payment');
      }else{
      window.top.location = createChannelUrl('paymentHistory');
      }

    };

    $scope.recurringPaymentlink=createChannelUrl('recurringPayment');
    $scope.showAutoPay = function(){
      if((UserSession.accountData.currentBalance === 0 || UserSession.accountData.currentBalance !== 0) &&  UserSession.accountData.activeMop){
        UserSession.autoPay.enabled=true;
        UserSession.paymentMethod=UserSession.accountData.activeMop.paymentMethodId;
        //UserSession.paymentMopType = UserSession.accountData.getMopById(UserSession.paymentMethod).payment.method;
        UserSession.autoPay.schedule=UserSession.accountData.activeMop.payment.frequency && UserSession.accountData.activeMop.payment.frequency=="IMMEDIATE"?0:UserSession.accountData.activeMop.payment.frequency;
        UserSession.reviewPageAutoPay.limit=UserSession.accountData.activeMop.payment.amount;
        //_paymentType="auto";*/
        return true;
      }else if(UserSession.accountData.currentBalance === 0){
        UserSession.autoPay.enabled=false;
        return true
      }
      return false;
      //return UserSession.accountData.currentBalance === 0 || (UserSession.accountData.currentBalance !== 0 && UserSession.autoPay.enabled === true);
    };
    var _registered = true;
    $scope.renewAch =function(){
      commonFunctionality.renewACH();
    };

    $scope.disableAutopay = function() {
      commonFunctionality.disableAutoPay();
    };
    // User is always registerd in this case
    $scope.$on('SERVER-ERROR', function(event, args) {
      $scope.SERVER_ERROR = true;
      // do what you want to do
    });

    //  Initialize the UserSession service
    UserSession.init(false,"RFR");
    $scope.content=wcmContent;
    $scope.session = UserSession;
    /**
     *  Viswa - z241843
     *  US282278: Stop using WCM for reading configuration values in Specialty Payments Components for Account Balance Page
     */
    // RequestServiceHelper.wcmService(CVS.Config.moduleWCM.widget).then(multipleWCMCall,wcmError);
    function multipleWCMCall(response) {

      var keyArr=CVS.Config.moduleWCM.widget.split(",");
      if(response){
        for(var key=0;key<keyArr.length;key++){
          if(response[keyArr[key]] && response[keyArr[key]].header && response[keyArr[key]].header.responseCode &&
              response[keyArr[key]].header.responseCode=="DBPL0000"){
            //$scope.wcmData[CVS.Config.wcmMapping[keyArr[key]]]=response[keyArr[key]].details[CVS.Config.wcmMapping[keyArr[key]]];
            var object = angular.merge({},  $scope.content[CVS.Config.wcmMapping[keyArr[key]]], response[keyArr[key]].details[CVS.Config.wcmMapping[keyArr[key]]]);
            $scope.content[CVS.Config.wcmMapping[keyArr[key]]]=object;
            //console.log("TEST-- ",CVS.Config.wcmMapping[keyArr[key]],object);
          }
        }
      }
      loadConfigError();
    };
    function wcmError(wcmError){
      loadConfigError();
    }

    function loadConfigError(){
      $scope.pendingPaymentAlertConfig = {
        alertType:"info",
        title: "",
        message: $scope.content.specialty_account_bal_payment.pymt_auth_content?$scope.content.specialty_account_bal_payment.pymt_auth_content:wcmContent.specialty_account_bal_payment.pymt_auth_content,
        suppressIcon: false
      }
     $scope.achRenewalAlertConfig = {
        alertType:"warn",
        title: "",
        message: $scope.content.specialty_recurring_payment.auto_pay_suspended?$scope.content.specialty_recurring_payment.auto_pay_suspended:wcmContent.specialty_recurring_payment.auto_pay_suspended,
        suppressIcon: false
      }
      if($rootScope.isMyAccount){
        $scope.errorMessageGeneral = {
          alertType:"warn",
          title: "",
          message: "<strong>Your current balance cannot be viewed right now.</strong><br>Check back later to see the amount.",
          suppressIcon: false
        }
      } else {
      $scope.errorMessageGeneral = {
        alertType:"error",
        title: "",
        message: "<strong>We're sorry.</strong><br>There was an error processing your request. Please try again, or connect to our technical support team from our ",
        suppressIcon: false,
        contactlink: "Contact Us"
      }
    }

    }
    
    function loadComponent() {
      loadConfigError();
    }
    
    loadComponent();

  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/widgets/accountBalance/accountBalance.template.html',
      //template:"<div> test </div>",
      controller: controllerFunction,
      link: linkFunction,
      scope: {
        isMyAccountPage: "="
      }
    }
  };

  controllerFunction.$inject = ["$scope","accountBalanceService","userSession","webAnalytics","commonFunctionality","RequestServiceHelper", "$rootScope"];
  angular.module('cvsApp').directive('accountBalance', directiveFunction);

})();
